import type { DocumentType } from "@/lib/api";
import { useTranslation } from "react-i18next";

const TYPE_COLORS: Record<string, string> = {
  Contract:
    "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  Annex:
    "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400",
  "Bank Credit": "bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400",
  "Sick Leave":
    "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  Visa: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400",
  ID: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
  "Driving License":
    "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  Passport:
    "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400",
  "Criminal Record":
    "bg-gray-100 text-gray-700 dark:bg-gray-800/50 dark:text-gray-400",
};

interface Props {
  type: DocumentType | null | undefined;
}

export function DocumentTypeBadge({ type }: Props) {
  const { t } = useTranslation();
  if (!type) return null;
  const cls = TYPE_COLORS[type] || "bg-secondary text-secondary-foreground";
  const translationKey = type.replace(/\s+/g, "");
  return (
    <span
      className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold ${cls}`}
    >
      {t(`documents.type.${translationKey}`, { defaultValue: type })}
    </span>
  );
}
